import { ref, computed, onMounted, onBeforeUnmount } from '@vue/composition-api'
import importApi from '@/services/api/import'

export default function useImportCard(type) {
  const status = ref(null)
  const statusData = ref({})
  const startLoading = ref(false)
  const resetLoading = ref(false)
  const downloadLoading = ref(false)
  const pollTimer = ref(null)

  const isRunning = computed(() => status.value === 'running' || status.value === 'pending')

  const progressPercent = computed(() => {
    const total = statusData.value.total
    const processed = statusData.value.processed
    if (!total || total === 0) return 0
    return Math.round((processed / total) * 100)
  })

  function applyData(data) {
    status.value = data.status
    statusData.value = data
  }

  function stopPolling() {
    if (pollTimer.value) {
      clearInterval(pollTimer.value)
      pollTimer.value = null
    }
  }

  async function poll() {
    try {
      const res = await importApi.getStatus(type)
      applyData(res.data.data)
      if (!isRunning.value) stopPolling()
    } catch (e) {
      stopPolling()
    }
  }

  function startPolling() {
    stopPolling()
    pollTimer.value = setInterval(poll, 2000)
  }

  async function fetchStatus() {
    try {
      const res = await importApi.getStatus(type)
      applyData(res.data.data)
      if (isRunning.value) startPolling()
    } catch (e) {
      status.value = 'idle'
    }
  }

  async function start() {
    startLoading.value = true
    try {
      await importApi.start(type)
      status.value = 'pending'
      statusData.value = {}
      startPolling()
    } finally {
      startLoading.value = false
    }
  }

  async function reset() {
    resetLoading.value = true
    try {
      await importApi.resetStatus(type)
      stopPolling()
      status.value = 'idle'
      statusData.value = {}
    } finally {
      resetLoading.value = false
    }
  }

  async function download() {
    downloadLoading.value = true
    try {
      const res = await importApi.downloadResult(type)
      const disposition = res.headers['content-disposition']
      let filename = `${type}.xlsx`
      if (disposition) {
        const match = disposition.match(/filename="?([^";]+)"?/)
        if (match) filename = match[1]
      }
      const url = URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } catch (_) { // handled by http interceptor
    } finally {
      downloadLoading.value = false
    }
  }

  onMounted(fetchStatus)
  onBeforeUnmount(stopPolling)

  return {
    status,
    statusData,
    startLoading,
    resetLoading,
    downloadLoading,
    isRunning,
    progressPercent,
    start,
    reset,
    download
  }
}



// WEBPACK FOOTER //
// ./src/composables/useImportCard.js